/* luterna – Filtern ohne Neuladen, "Mehr anzeigen", Warenkorb, Sofortsuche (ersetzt Boost) */
(function () {
  'use strict';
  var FARBEN = {
    'weiß': '#ffffff', 'elfenbein & creme': '#f1e8d2', 'schwarz & grau': '#555a5c', 'rot': '#b3261e', 'rosa & pink': '#e79ab4',
    'lila & violett': '#8e6bb3', 'orange': '#e98a2e', 'gelb': '#ecc945', 'braun & beige': '#a47b55', 'grün': '#6f9a4a',
    'blau': '#3f72b5', 'gold & silber': 'linear-gradient(135deg,#d4af37,#c0c0c0)'
  };

  function sortWert(t) {
    t = t.toLowerCase().replace(',', '.');
    if (t.indexOf('einzeln') === 0) return 1;
    if (t.indexOf('bis') === 0) return -1;
    if (t.indexOf('über') === 0) return 1e9;
    var m = t.match(/(\d+(?:\.\d+)?)/);
    var n = m ? parseFloat(m[1]) : 1e8;
    if (/tage/.test(t)) n *= 24;
    if (/ab 20|vorratspack/.test(t)) n = 1e6;
    return n;
  }
  function sortieren(root) {
    (root || document).querySelectorAll('[data-lt-sortieren]').forEach(function (ul) {
      var lis = Array.from(ul.children);
      lis.sort(function (a, b) { return sortWert(a.textContent.trim()) - sortWert(b.textContent.trim()); });
      lis.forEach(function (li, i) { li.classList.toggle('lt-mehr', i >= 8 && !li.querySelector('input:checked')); ul.appendChild(li); });
    });
  }
  function farbpunkte(root) {
    sortieren(root);
    (root || document).querySelectorAll('.lt-punkt[data-farbe]').forEach(function (el) {
      var f = FARBEN[el.dataset.farbe];
      if (f) el.style.background = f;
    });
  }

  var seite = document.getElementById('lt-seite');
  var laufend = null;

  function sectionUrl(url) {
    var u = new URL(url, location.origin);
    u.searchParams.set('section_id', seite.dataset.section);
    return u.toString();
  }

  function laden(url, anhaengen) {
    if (laufend) laufend.abort();
    laufend = new AbortController();
    if (!anhaengen) seite.classList.add('lt-laedt');
    return fetch(sectionUrl(url), { signal: laufend.signal })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var neu = doc.getElementById('lt-ergebnis');
        if (!neu) { location.href = url; return; }
        if (anhaengen) {
          var raster = seite.querySelector('[data-lt-raster]');
          neu.querySelectorAll('[data-lt-raster] > *').forEach(function (k) { raster.appendChild(k); });
          var alt = seite.querySelector('.lt-mehr-wrap'), nw = neu.querySelector('.lt-mehr-wrap');
          if (alt) alt.replaceWith(nw || document.createElement('span'));
        } else {
          var offen = Array.from(seite.querySelectorAll('.lt-filtergruppe')).map(function (d) { return d.open; });
          var scroll = seite.querySelector('[data-lt-leiste]').scrollTop;
          seite.querySelector('#lt-ergebnis').replaceWith(neu);
          seite.querySelectorAll('.lt-filtergruppe').forEach(function (d, i) { if (offen[i] !== undefined) d.open = offen[i]; });
          seite.querySelector('[data-lt-leiste]').scrollTop = scroll;
          var anz = doc.querySelector('[data-lt-anzahl]'), ziel = seite.querySelector('[data-lt-anzahl]');
          if (anz && ziel) ziel.textContent = anz.textContent;
          history.replaceState({}, '', url);
        }
        farbpunkte(seite);
        if (!anhaengen) verfuegbarZuerst(url);
      })
      .catch(function (e) { if (e.name !== 'AbortError') location.href = url; })
      .finally(function () { seite.classList.remove('lt-laedt'); });
  }

  /* Lieferbare Produkte zuerst, ausverkaufte am Ende (Shopify kann das nicht nativ) */
  var AV = 'filter.v.availability';
  function mitVerfuegbarkeit(url, wert) {
    var u = new URL(url, location.origin);
    u.searchParams.delete(AV); u.searchParams.delete('page'); u.searchParams.set(AV, wert);
    return u.pathname + u.search;
  }
  function holeSeite(url) {
    return fetch(sectionUrl(url)).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var weiter = doc.querySelector('[data-lt-mehr-laden]');
      return { karten: Array.from(doc.querySelectorAll('[data-lt-raster] > .lt-karte')), weiter: weiter ? weiter.getAttribute('href') : null };
    });
  }
  function mehrKnopf(raster, url, phase) {
    var alt = seite.querySelector('.lt-mehr-wrap'); if (alt) alt.remove();
    if (!url) return;
    var w = document.createElement('div'); w.className = 'lt-mehr-wrap';
    w.innerHTML = '<button type="button" class="lt-knopf lt-knopf--hell">Mehr anzeigen</button>';
    raster.after(w);
    w.querySelector('button').onclick = function () {
      this.setAttribute('aria-busy', 'true'); this.textContent = 'Lädt …';
      weiterLaden(url, phase);
    };
  }
  var basisUrl = null;
  function ausverkauftAnhaengen(raster) {
    return holeSeite(mitVerfuegbarkeit(basisUrl, 0)).then(function (s2) {
      if (!s2.karten.length) { mehrKnopf(raster, null); return; }
      var h = document.createElement('h2'); h.className = 'lt-ausverkauft-titel'; h.textContent = 'Zurzeit ausverkauft';
      raster.appendChild(h);
      s2.karten.forEach(function (k) { raster.appendChild(k); });
      mehrKnopf(raster, s2.weiter, 0);
    });
  }
  function weiterLaden(url, phase) {
    var raster = seite.querySelector('[data-lt-raster]');
    holeSeite(url).then(function (s1) {
      s1.karten.forEach(function (k) { raster.appendChild(k); });
      farbpunkte(seite);
      if (s1.weiter) mehrKnopf(raster, s1.weiter, phase);
      else if (phase === 1) ausverkauftAnhaengen(raster).then(function () { farbpunkte(seite); });
      else mehrKnopf(raster, null);
    });
  }
  function verfuegbarZuerst(url) {
    if (!seite || seite.dataset.typ !== 'sammlung') return;
    var u = new URL(url || location.href, location.origin);
    if (u.searchParams.has(AV) || (u.searchParams.get('page') || '1') !== '1') return;
    if (!seite.querySelector('.lt-marke--aus')) return;   // nichts Ausverkauftes auf der ersten Seite
    basisUrl = u.pathname + u.search;
    var raster = seite.querySelector('[data-lt-raster]');
    raster.style.minHeight = raster.offsetHeight + 'px';
    holeSeite(mitVerfuegbarkeit(basisUrl, 1)).then(function (s1) {
      raster.innerHTML = '';
      s1.karten.forEach(function (k) { raster.appendChild(k); });
      var fort = seite.querySelector('.lt-fortschritt'); if (fort) fort.remove();
      if (s1.weiter) mehrKnopf(raster, s1.weiter, 1);
      else return ausverkauftAnhaengen(raster);
    }).then(function () { raster.style.minHeight = ''; farbpunkte(seite); })
      .catch(function () { raster.style.minHeight = ''; });
  }

  /* Endlos-Scroll: beim Erreichen des Listenendes automatisch nachladen */
  var beobachter = 'IntersectionObserver' in window ? new IntersectionObserver(function (eintraege) {
    eintraege.forEach(function (e) {
      if (!e.isIntersecting) return;
      var k = e.target.querySelector('button, a[data-lt-mehr-laden]');
      if (k && k.getAttribute('aria-busy') !== 'true') k.click();
    });
  }, { rootMargin: '900px 0px' }) : null;
  function endlos() {
    if (!beobachter || !seite) return;
    beobachter.disconnect();
    var w = seite.querySelector('.lt-mehr-wrap');
    if (w) {
      w.classList.add('lt-endlos');
      var k = w.querySelector('button, a[data-lt-mehr-laden]');
      var txt = 'Weitere Produkte werden geladen …';
      if (k && k.getAttribute('aria-busy') !== 'true' && k.textContent !== txt) k.textContent = txt;
      beobachter.observe(w);
    }
  }
  var scrollTimer = null;
  window.addEventListener('scroll', function () {   // Rückfall, falls IntersectionObserver nicht feuert
    if (scrollTimer || !seite) return;
    scrollTimer = setTimeout(function () {
      scrollTimer = null;
      var w = seite.querySelector('.lt-mehr-wrap.lt-endlos');
      if (!w) return;
      if (w.getBoundingClientRect().top < window.innerHeight + 900) {
        var k = w.querySelector('button, a[data-lt-mehr-laden]');
        if (k && k.getAttribute('aria-busy') !== 'true') k.click();
      }
    }, 150);
  }, { passive: true });
  new MutationObserver(function () { endlos(); }).observe(document.getElementById('lt-seite') || document.createElement('div'), { childList: true, subtree: true });

  function formularUrl(form) {
    var fd = new FormData(form), p = new URLSearchParams();
    fd.forEach(function (v, k) { if (v !== '') p.append(k, v); });
    var sort = seite.querySelector('[data-lt-sort]');
    if (sort) p.set('sort_by', sort.value);
    var basis = form.getAttribute('action');
    var qs = p.toString();
    return basis + (qs ? '?' + qs : '');
  }

  if (seite) {
    farbpunkte(seite);
    verfuegbarZuerst();
    endlos();
    var timer;
    seite.addEventListener('change', function (e) {
      var form = e.target.closest('[data-lt-filter]');
      if (e.target.matches('[data-lt-sort]')) form = seite.querySelector('[data-lt-filter]');
      if (!form) return;
      clearTimeout(timer);
      timer = setTimeout(function () { laden(formularUrl(form)); }, e.target.type === 'number' ? 600 : 50);
    });
    seite.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-lt-filter]');
      if (form) { e.preventDefault(); laden(formularUrl(form)); }
    });
    seite.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-lt-link]');
      if (a) { e.preventDefault(); laden(a.href); return; }
      var mehr = e.target.closest('[data-lt-mehr-laden]');
      if (mehr) { e.preventDefault(); mehr.setAttribute('aria-busy', 'true'); mehr.textContent = 'Lädt …'; laden(mehr.href, true); return; }
      if (e.target.closest('[data-lt-mehr]')) {
        var b = e.target.closest('[data-lt-mehr]'), liste = b.previousElementSibling;
        liste.classList.toggle('lt-alle');
        b.textContent = liste.classList.contains('lt-alle') ? 'Weniger anzeigen' : 'Alle anzeigen';
        return;
      }
      if (e.target.closest('[data-lt-filter-auf]')) { filterMenu(true); return; }
      if (e.target.closest('[data-lt-filter-zu]')) { filterMenu(false); return; }
    });
    var hinter = document.createElement('div');
    hinter.className = 'lt-filter-hinter'; hinter.setAttribute('aria-hidden', 'true');
    hinter.addEventListener('click', function () { filterMenu(false); });
    document.body.appendChild(hinter);
    function filterMenu(auf) {
      document.body.classList.toggle('lt-filter-offen', auf);
      document.documentElement.classList.toggle('lt-filter-offen', auf);
      document.querySelectorAll('[id^="trustbadge-container"], #tuv-saarland, .authorized-icon').forEach(function (el) {
        el.style.setProperty('visibility', auf ? 'hidden' : '', auf ? 'important' : '');
      });
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') filterMenu(false); });
  }

  /* In den Warenkorb (Produkte ohne Varianten) */
  var toastTimer;
  function toast(html) {
    var t = document.querySelector('[data-lt-toast]');
    if (!t) { t = document.createElement('div'); t.className = 'lt-toast'; t.setAttribute('data-lt-toast', ''); document.body.appendChild(t); }
    t.innerHTML = html; t.classList.add('lt-zeigen');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('lt-zeigen'); }, 4500);
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  document.addEventListener('click', function (e) {
    var k = e.target.closest('[data-lt-kaufen]');
    if (!k) return;
    e.preventDefault();
    k.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: +k.dataset.ltKaufen, quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'Fehler'); return j; }); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.querySelectorAll('#cartCount, .cart-count, [data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        toast('<span>„' + esc(k.dataset.titel).slice(0, 60) + '“ liegt im Warenkorb</span><a href="/cart">Zum Warenkorb</a>');
      })
      .catch(function (err) { toast('<span>' + esc(err.message) + '</span>'); })
      .finally(function () { k.removeAttribute('aria-busy'); });
  });

  /* Sofortsuche für alle Suchfelder */
  function sofortsuche(input, behaelter) {
    if (input.dataset.ltSuche) return;
    input.dataset.ltSuche = '1';
    input.setAttribute('autocomplete', 'off');
    var box = document.createElement('div');
    box.className = 'lt-vorschlag' + (behaelter ? ' lt-vorschlag--fest' : ''); box.hidden = true; box.setAttribute('role', 'listbox');
    (behaelter || document.body).appendChild(box);
    var zeit, ctrl, fokus = -1;
    function platzieren() {
      if (behaelter) return;
      var r = input.getBoundingClientRect();
      var links = Math.min(r.left + window.scrollX, window.scrollX + document.documentElement.clientWidth - box.offsetWidth - 12);
      box.style.left = Math.max(12 + window.scrollX, links) + 'px';
      box.style.top = (r.bottom + window.scrollY + 6) + 'px';
    }
    function zu() { box.hidden = true; fokus = -1; }
    function zeigen(q, d) {
      var r = d.resources.results, html = '';
      if ((r.queries || []).length) html += '<h4>Vorschläge</h4>' + r.queries.slice(0, 4).map(function (x) {
        return '<a href="/search?q=' + encodeURIComponent(x.text) + '&options[prefix]=last&options[unavailable_products]=last">' + x.styled_text + '</a>'; }).join('');
      if ((r.collections || []).length) html += '<h4>Kategorien</h4>' + r.collections.slice(0, 4).map(function (c) {
        return '<a href="' + c.url + '">' + esc(c.title) + '</a>'; }).join('');
      if ((r.products || []).length) html += '<h4>Produkte</h4>' + r.products.slice(0, 6).map(function (p) {
        return '<a href="' + p.url + '">' + (p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '&width=96" alt="" loading="lazy">' : '') +
          '<span>' + esc(p.title) + '</span><span class="lt-v-preis">' + (p.price ? Number(p.price).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }) : '') + '</span></a>'; }).join('');
      if ((r.articles || []).length) html += '<h4>Ratgeber</h4>' + r.articles.slice(0, 3).map(function (a) {
        return '<a href="' + a.url + '">' + esc(a.title) + '</a>'; }).join('');
      html = html ? html + '<a class="lt-v-alle" href="/search?q=' + encodeURIComponent(q) + '&options[prefix]=last&options[unavailable_products]=last">Alle Ergebnisse für „' + esc(q) + '“</a>'
                  : '<div class="lt-v-leer">Keine Treffer für „' + esc(q) + '“ – probier z. B. „Stumpenkerze“ oder „Grablicht“.</div>';
      box.innerHTML = html; box.hidden = false; fokus = -1; platzieren();
    }
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(zeit);
      if (q.length < 2) { zu(); return; }
      zeit = setTimeout(function () {
        if (ctrl) ctrl.abort(); ctrl = new AbortController();
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,article,query&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag',
          { signal: ctrl.signal })
          .then(function (r) { return r.json(); }).then(function (d) { if (input.value.trim() === q) zeigen(q, d); }).catch(function () {});
      }, 180);
    });
    input.addEventListener('keydown', function (e) {
      var links = box.hidden ? [] : box.querySelectorAll('a');
      if (e.key === 'ArrowDown' && links.length) { e.preventDefault(); fokus = (fokus + 1) % links.length; }
      else if (e.key === 'ArrowUp' && links.length) { e.preventDefault(); fokus = (fokus - 1 + links.length) % links.length; }
      else if (e.key === 'Enter' && fokus >= 0) { e.preventDefault(); location.href = links[fokus].href; return; }
      else if (e.key === 'Escape') { zu(); return; } else return;
      links.forEach(function (a, i) { a.classList.toggle('lt-fokus', i === fokus); });
    });
    if (!behaelter) document.addEventListener('click', function (e) { if (e.target !== input && !box.contains(e.target)) zu(); });
    window.addEventListener('resize', function () { if (!box.hidden) platzieren(); });
    window.addEventListener('scroll', function () { if (!box.hidden) platzieren(); }, { passive: true });
  }
  var mobil = null, hinter = null;
  function sucheZu() {
    if (!mobil) return;
    mobil.classList.remove('lt-offen'); hinter.classList.remove('lt-offen'); document.documentElement.classList.remove('lt-msuche-aktiv');
  }
  function mobilSuche(start) {
    if (!mobil) {
      mobil = document.createElement('div');
      mobil.className = 'lt-msuche'; mobil.setAttribute('role', 'dialog'); mobil.setAttribute('aria-label', 'Suche');
      mobil.innerHTML = '<form class="lt-msuche__kopf" action="/search" method="get" role="search">' +
        '<input type="search" name="q" placeholder="Was suchst du?" aria-label="Suche" enterkeyhint="search">' +
        '<input type="hidden" name="options[prefix]" value="last"><input type="hidden" name="options[unavailable_products]" value="last">' +
        '<button type="button" class="lt-msuche__zu" aria-label="Suche schließen">Abbrechen</button></form>' +
        '<div class="lt-msuche__inhalt"><p class="lt-msuche__tipp">Tipp: Suche nach Produkt, Farbe oder Größe – z. B. „rote Stumpenkerze“, „Grablicht 7 Tage“ oder „Teelichter 100“.</p></div>';
      document.body.appendChild(mobil);
      var feld = mobil.querySelector('input[name=q]');
      sofortsuche(feld, mobil.querySelector('.lt-msuche__inhalt'));
      feld.addEventListener('input', function () { var t = mobil.querySelector('.lt-msuche__tipp'); if (t) t.hidden = feld.value.trim().length >= 2; });
      mobil.querySelector('.lt-msuche__zu').addEventListener('click', sucheZu);
      hinter = document.createElement('div'); hinter.className = 'lt-msuche-hinter'; hinter.addEventListener('click', sucheZu);
      document.body.appendChild(hinter);
    }
    var f = mobil.querySelector('input[name=q]');
    if (start) f.value = start;
    mobil.classList.add('lt-offen'); hinter.classList.add('lt-offen'); document.documentElement.classList.add('lt-msuche-aktiv');
    f.focus();
    if (f.value) f.dispatchEvent(new Event('input'));
  }
  document.addEventListener('focusin', function (e) {
    var i = e.target;
    if (i.matches && i.matches('.mobile_search input[name=q], #toggle-search input[name=q]')) { i.blur(); mobilSuche(i.value); }
  });
  document.addEventListener('click', function (e) {
    var i = e.target.closest && e.target.closest('.mobile_search, #toggle-search');
    if (i) { e.preventDefault(); mobilSuche(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') sucheZu(); });

  function alleSuchfelder() {
    document.querySelectorAll('form[action="/search"] input[name="q"], form[action$="/search"] input[name="q"]').forEach(function (i) {
      if (!i.closest('.mobile_search, #toggle-search, .lt-msuche')) sofortsuche(i);
      var f = i.form;
      if (f && !f.querySelector('input[name="options[unavailable_products]"]')) {
        var h = document.createElement('input'); h.type = 'hidden'; h.name = 'options[unavailable_products]'; h.value = 'last'; f.appendChild(h);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alleSuchfelder); else alleSuchfelder();

  // ---------- Produktreihen „Ähnliche Artikel“ / „Passend dazu“ ----------
  document.querySelectorAll('[data-lt-reihe]').forEach(function (r) {
    var spur = r.querySelector('[data-lt-reihe-spur]'), zur = r.querySelector('[data-lt-reihe-zurueck]'), vor = r.querySelector('[data-lt-reihe-vor]');
    function pfeile() {
      zur.disabled = spur.scrollLeft < 5;
      vor.disabled = spur.scrollLeft + spur.clientWidth > spur.scrollWidth - 5;
      r.classList.toggle('lt-reihe--passt', zur.disabled && vor.disabled);
    }
    function schieben(richtung) { spur.scrollBy({left: richtung * spur.clientWidth * 0.9, behavior: 'smooth'}); }
    zur.addEventListener('click', function () { schieben(-1); });
    vor.addEventListener('click', function () { schieben(1); });
    spur.addEventListener('scroll', pfeile, {passive: true});
    window.addEventListener('resize', pfeile);
    pfeile();
  });

  // ---------- Cookie-Banner frei halten ----------
  // Das Chat-Widget (Wizybot) legt ein unsichtbares 80×80-Feld über die Knöpfe „Akzeptieren“/„Ablehnen“, das Trusted-Shops-
  // Siegel liegt ebenfalls darüber. Solange das Shopify-Cookie-Banner offen ist, werden beide ausgeblendet.
  (function () {
    var STOERER = 'iframe[id^="WizybotShopifyWidget"], #wizydiv, [id^="trustbadge-container"], [id^="minimized-trustbadge"], #tuv-saarland';
    var war = false, start = Date.now();
    function offen() {
      var b = document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs, .shopify-pc__prefs__dialog');
      for (var i = 0; i < b.length; i++) if (b[i].offsetHeight > 0 && getComputedStyle(b[i]).visibility !== 'hidden') return true;
      return false;
    }
    function pruefen() {
      var auf = offen();
      if (auf || war) {
        document.querySelectorAll(STOERER).forEach(function (el) {
          // display statt visibility: Kind-Elemente des Siegels setzen sich selbst wieder sichtbar
          if (auf && !('ltDisplay' in el.dataset)) {
            el.dataset.ltDisplay = el.style.getPropertyValue('display') + '|' + el.style.getPropertyPriority('display');
            el.style.setProperty('display', 'none', 'important');
          } else if (!auf && 'ltDisplay' in el.dataset) {
            var alt = el.dataset.ltDisplay.split('|');
            el.style.setProperty('display', alt[0], alt[1]);
            delete el.dataset.ltDisplay;
          }
        });
      }
      war = auf;
      // nach 10 Minuten ohne Banner aufhören
      if (!auf && Date.now() - start > 600000) clearInterval(t);
    }
    var t = setInterval(pruefen, 500);
    document.addEventListener('click', function () { setTimeout(pruefen, 50); }, true);
  })();

  // ---------- „Praktisch im Set“ (Produktseite) ----------
  function setInit(sec) {
    var rabatt = parseFloat(sec.dataset.rabatt) || 0, code = sec.dataset.code || '';
    var varianten = {};
    try { varianten = JSON.parse(sec.querySelector('[data-lt-set-varianten]').textContent); } catch (e) {}
    var form = document.getElementById('AddToCartForm');
    var eur = function (c) { return '€' + (c / 100).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}); };   // wie das Shop-Format „€40,90“
    function hauptId() {
      var f = form && form.querySelector('[name="id"]');
      return f && varianten[f.value] ? f.value : Object.keys(varianten)[0];
    }
    function wahl() { return [].slice.call(sec.querySelectorAll('[data-lt-set-wahl]')); }
    function rechnen() {
      var h = varianten[hauptId()] || {preis: 0, titel: ''};
      sec.querySelector('[data-lt-set-hauptpreis]').textContent = eur(h.preis);
      var hv = sec.querySelector('[data-lt-set-hauptvar]'); if (hv) hv.textContent = h.titel;
      var summe = h.preis, rabattBetrag = Math.floor(h.preis * rabatt), alle = true, n = 1;   // Shopify rundet je Artikel ab
      wahl().forEach(function (cb) {
        var karte = cb.closest('[data-lt-set-karte]'), sel = karte.querySelector('[data-lt-set-variante]');
        if (sel) { cb.value = sel.value; cb.dataset.preis = sel.selectedOptions[0].dataset.preis; }
        karte.querySelector('[data-lt-set-preis]').textContent = eur(+cb.dataset.preis);
        karte.classList.toggle('lt-aus', !cb.checked);
        if (cb.checked) { summe += +cb.dataset.preis; rabattBetrag += Math.floor(+cb.dataset.preis * rabatt); n++; } else alle = false;
      });
      var mitRabatt = alle && rabatt > 0 && code;
      sec.querySelector('[data-lt-set-summe]').textContent = eur(mitRabatt ? summe - rabattBetrag : summe);
      sec.querySelector('[data-lt-set-alt]').textContent = mitRabatt ? eur(summe) : '';
      sec.querySelector('[data-lt-set-kaufen]').textContent = n === 1 ? 'In den Warenkorb' : (alle ? 'Alle ' + n + ' in den Warenkorb' : n + ' Artikel in den Warenkorb');
      var hin = sec.querySelector('[data-lt-set-hinweis]');
      hin.hidden = !(rabatt > 0 && code && !alle); hin.textContent = 'Den Set-Rabatt von 5 % gibt es, wenn alle Artikel ausgewählt sind.';
      return {alle: alle, mitRabatt: mitRabatt};
    }
    sec.addEventListener('change', rechnen);
    if (form) { form.addEventListener('change', function () { setTimeout(rechnen, 60); }); form.addEventListener('click', function () { setTimeout(rechnen, 60); }); }
    sec.querySelector('[data-lt-set-kaufen]').addEventListener('click', function () {
      var knopf = this, st = rechnen();
      var items = [{id: +hauptId(), quantity: 1}].concat(wahl().filter(function (cb) { return cb.checked; }).map(function (cb) { return {id: +cb.value, quantity: 1}; }));
      knopf.disabled = true; knopf.classList.add('lt-laedt');
      fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items: items})})
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Fehler'); return d; }); })
        .then(function () { return st.mitRabatt ? fetch('/discount/' + encodeURIComponent(code), {credentials: 'same-origin'}) : null; })
        .then(function () { location.href = '/cart'; })
        .catch(function (e) {
          var hin = sec.querySelector('[data-lt-set-hinweis]'); hin.hidden = false; hin.textContent = 'Konnte nicht in den Warenkorb gelegt werden: ' + e.message;
          knopf.disabled = false; knopf.classList.remove('lt-laedt');
        });
    });
    rechnen();
  }
  function alleSets() { document.querySelectorAll('[data-lt-set]').forEach(setInit); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alleSets); else alleSets();
})();
